export default __webpack_public_path__ + "static/media/intro1.9f12612b.mp4";